/**
 * Environment Configuration (environment.prod.ts)
 * -----------------------------------------------------------
 * @author Beau Liddell <ibeau.liddell@childrenshospitals.org>
 * @modified 2024-12-19
 * @modifiedBy Anthony Grado <anthony.grado@childrenshospitals.org>
 * @description Entry-point environment (env) file containing common environment-specific system variables used by the app. This file's contents will be replaced by the contents of the specified build configuration.
 *  If no configuration is specified, this file will be used as-is.
 * @usage If you specify the environment name using `builddev` (shortcut) or `ng build --configuration=dv --base-href /hub/` then the contents of `environment.dev.ts` will be used.
 *  The list of env maps can be found in `.angular.json`. Shortcuts can be found in `package.json`
 */
const envName: string = "prod";
const buildPath: string = "./dist/";
const envDomain: string = "//learning" + (envName == "prod" ? "" : envName) + ".childrenshospitals.org";
const protocol: string = location.protocol;
const port: string = "";
const appBaseHref: string = "/hub/";
const plsSupport = "learningsupport@childrenshospitals.org";

const storageAccount = "chapls";
const memberShareName: string = "hospital-hosted";
const storageContainer = envName == "prod" ? "pls-blob-prod" : "pls-blob-devqa";
const storageURL = "https://" + storageAccount + ".blob.core.windows.net/" + storageContainer;

export const environment = {
	"production": true,
	"envName": appBaseHref,
	"output-path": buildPath + envName + "/",
	// Host Protocol
	"protocol": protocol,
	"port": port,
	// Host domain
	"envDomain": envDomain,
	// BaseHREF
	"appBaseHref": appBaseHref,
	// Full Base URI Path
	"fullBaseURI": protocol + envDomain + port + appBaseHref,
	// API URI
	"apiUrl": protocol + envDomain + "/websvc/api",
	// APP URL -- Handling User Validation Request
	"appURL": protocol + envDomain + "/websvc/app",
	// Azure Storage Location
	"storageURL": storageURL,
	// PLS Support Email Address
	"plsSupport": plsSupport,
	// Member Hosted Content Azure ShareName
	"memberShareName": memberShareName
};
